import { render, staticRenderFns } from "./AssesmentCombo.vue?vue&type=template&id=125b51ae&scoped=true"
import script from "./AssesmentCombo.vue?vue&type=script&lang=js"
export * from "./AssesmentCombo.vue?vue&type=script&lang=js"
import style0 from "./AssesmentCombo.vue?vue&type=style&index=0&id=125b51ae&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125b51ae",
  null
  
)

export default component.exports